var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"__user_button",on:{"click":function($event){return _vm.open()}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'user']}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }